<script setup lang="ts">
import AuthLayout from '@/layouts/client/auth.vue'
import { useForm } from '@inertiajs/vue3'
import VueTurnstile from 'vue-turnstile'
import { Loader, Info } from 'lucide-vue-next'

defineOptions({
  layout: AuthLayout
})
defineProps<{
  siteKey: string,
  isSent: boolean
}>()

const form = useForm({
  email: '',
  turnstile: '',
})
</script>

<template>
  <AppHead title="Forgot password" description="Retrieve your password for Footy Tipping competition management." />
  <FTFormWrapper title="Forgot password">
    <template v-slot:subtitle>
      <p v-if="!isSent">Enter your email below to reset your account password</p>
      <p v-else>If the email address you entered is associated with an account, you will receive an email with
        instructions on how
        to reset your password.</p>
    </template>

    <div v-if="!isSent">
      <form class="grid gap-4"
        @submit.prevent="form.post('/client/forgot-password', { onSuccess: () => form.reset(), preserveScroll: true })">
        <FTInput id="email" name="email" label="Email" type="email" v-model="form.email" :error="form.errors.email"
          :disabled="form.processing" placeholder="me@example.com" />
        <vue-turnstile :site-key="siteKey" v-model="form.turnstile" theme="light" appearance="interaction-only" />
        <Button type="submit" class="w-full" :disabled="form.processing">
          <Loader v-if="form.processing" class="mr-2 w-4 h-4 animate-spin" />
          Reset password
        </Button>
      </form>
      <div class="mt-4 text-sm">
        Remembered your password?
        <Link href="/login" class="underline">
        Log in here
        </Link>
      </div>
    </div>
  </FTFormWrapper>
</template>
